import { FC } from "react";
import { CampaignType } from "@vviinn/user-managment-client-ts";
import { Rocket } from "lucide-react";

import { NamedRadio } from "../../../ui/layout/molecules/NamedRadio";
import { styledIcon } from "../../../ui/layout/general/styledIcon";
import { MEDIUM_ICON_SIZE_STYLES } from "../../../ui/styles";
import { useAppSelector } from "../../../store";
import { campaignTypes, campaignTypeTitles } from "../../constants";
import { StateAction } from "../../../helpers/functions/types";

export const CampaignTypeRadio: FC<{
  campaignType?: CampaignType | "BOOSTING";
  setCampaignType: StateAction<CampaignType | "BOOSTING" | undefined>;
}> = ({ campaignType, setCampaignType }) => {
  const allowedServices = useAppSelector(
    (state) => state.company?.company?.allowedServices,
  );

  if (!allowedServices) return null;

  return (
    <NamedRadio
      title="Campaign Type"
      value={campaignType}
      customId="type"
      onChange={(value) => setCampaignType(value as CampaignType | "BOOSTING")}
      options={[
        ...campaignTypes.map((type) => ({
          value: type,
          title: campaignTypeTitles[type],
          disabled: !allowedServices.includes(type),
          icon: styledIcon(type, MEDIUM_ICON_SIZE_STYLES),
        })),
        {
          value: "BOOSTING",
          title: "Boosting",
          icon: <Rocket className={MEDIUM_ICON_SIZE_STYLES} />,
        },
      ]}
      radioVariant="wideButtons"
      disabledMessage="This campaign type is not included in the current plan."
      requiredMessage="Please select campaign type"
    />
  );
};
